<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h410_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="年份"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.year"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="月份"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.month"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="地区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="品规"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.productName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="数量"
                    prop="amount"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.amount"
                      :disabled="eventType==='view'"
                      @input="(val)=>{computedMathRow(val, dialogAddEditViewForm, 'amount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'amount', 2)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { initMarketProductPlanApi, saveOrUpdateMarketProductPlanApi } from '@/api/marketProductPlan'
export default {
  components: { },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        amount: [ { required: true, message: '请输入数量', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' } ]
      },
      provinceOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.provinceOptions = []
        this.dialogAddEditViewForm = {
          year: '',
          month: '',
          cityName: '',
          productName: '',
          amount: 0,
          remark: ''
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initMarketProductPlanApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 计算合计
    computedMathRow (val, obj, name) {
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '访销品规计划','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateMarketProductPlanApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
